<template>
  <!-- top3 -->
  <q-section v-bind="$attrs">
    <q-section v-for="(item, index) in props.top3" :bg-i="item.bg" v-bind="genConfig(index)">
      <DoubleUsers :user1="item.user1" :user2="item.user2" v-bind="item.avatarPosition"
        @avatar-click="handleAvatarClick">
      </DoubleUsers>
      <q-section v-bind="item.nicknamePosition" class="text-center ellipsis flex flex-col">
        <q-section p="relative"> {{ item.user1?.nickname }}</q-section>
        <q-section p="relative"> {{ item.user2?.nickname }}</q-section>
      </q-section>
      <q-section v-bind="item.scorePosition" class="text-center text-nowrap">
        {{ item[item.scoreType] }}
      </q-section>
      <q-section v-bind="item.unitPosition" class="text-center text-nowrap">
        {{ item.unit }}
      </q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import DoubleUsers from './double-users.vue'
const props = defineProps<{
  top3: any[]
}>()

const emit = defineEmits<{
  (e: 'avatarClick', userId: number): void
}>()

const handleAvatarClick = (userId: number) => {
  emit('avatarClick', userId)
}

const genConfig = (index: number) => {
  const map = {
    0: { pc: 'x', pt: '0' },
    1: { pl: '0', pb: '0' },
    2: { pr: '0', pb: '0' },
  } as const
  return map[index as keyof typeof map]
}
</script>

<style scoped lang="scss">
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
